import { render } from "./Col11.vue?vue&type=template&id=fc2bbdc6"
import script from "./Col11.vue?vue&type=script&lang=js"
export * from "./Col11.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__